import { AOActionCodeEnum, AvailableAction } from 'types/ActivationOrderTypes';

// Бэкенд отдаёт короткие лейблы (Sign, Delete), в макетах — Sign AO и Delete AO
const ACTION_LABEL_KEYS: Record<string, string> = {
  [AOActionCodeEnum.SIGN]: 'forms.activationOrder.signAoTitle',
  [AOActionCodeEnum.DELETE]: 'forms.activationOrder.deleteAo',
  [AOActionCodeEnum.ARCHIVE]: 'forms.activationOrder.archiveAo',
};

export const getActionLabel = (action: AvailableAction, t: (key: string) => string): string => {
  const labelKey = ACTION_LABEL_KEYS[action.code];

  return labelKey ? t(labelKey) : action.label;
};

export default getActionLabel;
